export interface ILogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export function Logo({ width = 123, height = 53, className }: ILogoProps) {
  return (
    <img
      src="/levelup/logo.svg"
      alt="LevelUp"
      width={width}
      height={height}
      className={className}
      draggable={false}
    />
  );
}
